
export class OpusWrapper {
/**
 * @param {?} blob
 * @return {?}
 */
public static encode(blob: Blob | File): Promise<Blob> {
    return new Promise<Blob>((resolve, reject) => {
      const /** @type {?} */ opusWorker = new Worker('/tp-audio-editor/opus/EmsWorkerProxy.js');
      const /** @type {?} */ reader = new FileReader();
      reader.onloadend = () => {
        const /** @type {?} */ args = [
          'in',
          'out'
        ];
        const /** @type {?} */ inData = {};
        inData['in'] = new Uint8Array(reader.result);
        const /** @type {?} */ outData = {
          'out': {
            'MIME': 'audio/ogg'
          }
        };

        opusWorker.onmessage = e => {
          if (!e.data) {
            return;
          }
          if (e.data.reply === 'done') {
            opusWorker.terminate();
            resolve(e.data.values['out'].blob);
          } else if (e.data.reply === 'err') {
            opusWorker.terminate();
            reject('Error occured while encoding to opus');
          }
        };
        opusWorker.onerror = e => {
          opusWorker.terminate();
          reject(e);
        };
        opusWorker.postMessage({
          command: 'encode',
          args: args,
          outData: outData,
          fileData: inData
        });
      };
      reader.readAsArrayBuffer(blob);
    });
  }
}
